export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function generateRandomAlphaNumericString() {
  return (Math.random() + 1).toString(36).substring(2);
}
